/* eslint-disable react-hooks/exhaustive-deps */
import SeguimientoIcon from "../../../../icons/SeguimientoYMonitoreo/SeguimientoIcons";
import {OverlayPanel} from "primereact/overlaypanel";
import {useEffect, useRef, useState} from "react";
import {colorIndicadores, tipoIndicador} from "../SeguimentoConstantes";
import {useSeguimientoMonitoreo} from "../SeguimientoMonitoreoProvider";
import {
    botonPanico,
    contadorTotales, despacho,
    horasDeManejo,
    indicadoresBrecha,
    indicadoresDiesel,
    indicadoresGeocercaProhibida, indicadoresGps,
    indicadoresLastPosition,
    indicadoresMotor, indicadoresUnidadSinViaje,
    indicadoresVelocidad, seguimiento
} from "./configuracionTotales";
import {addIfVisible} from "../SeguimientoMonitoreutility";


const TotalIndicadores = ({soloUnidades}) => {
    const op = useRef(null);
    const [indicador, setIndicador] = useState({opciones: []})
    const [totales, setTotales] = useState(new Map())
    const [icons,setIcons] = useState([])

    const {indicadoresVisibles, viajes, filtro, viajesFiltrados} = useSeguimientoMonitoreo()

const colorIdsSeleccionados =
    filtro.value.indicadorId == null
        ? []
        : Array.isArray(filtro.value.colorIds)
            ? filtro.value.colorIds
            : filtro.value.colorId != null
                ? [filtro.value.colorId]
                : [];

const filtroSeleccionado = {
    indicadorId: filtro.value.indicadorId,
    colorIds: colorIdsSeleccionados
};

const seleccionarFiltro = (indicadorId, colorId) => {
    const coloresActuales =
        filtroSeleccionado.indicadorId === indicadorId
            ? filtroSeleccionado.colorIds
            : [];

    const colorIds = coloresActuales.includes(colorId)
        ? coloresActuales.filter(id => id !== colorId)
        : [...coloresActuales, colorId];

    filtro.setValue({
        ...filtro.value,
        indicadorId: colorIds.length > 0 ? indicadorId : null,
        colorIds,
        colorId: null
    });
};
    const mostrarDetalle = (e, indicador) => {
        setIndicador(indicador)
        op.current.toggle(e)
    }


    const obtenerMapIndicadorValue = (indicadorId) => {
        const opciones = icons.find(icon => icon.id === indicadorId)?.opciones ?? contadorTotales;
        return [indicadorId, new Map(opciones.map(o => [o.colorId, 0]))]
    }

    const obtenerTotales = (viajes) => {
        let totales = new Map([
            obtenerMapIndicadorValue(tipoIndicador.velocidad),
            obtenerMapIndicadorValue(tipoIndicador.motor),
            obtenerMapIndicadorValue(tipoIndicador.geocercaProhibida),
            obtenerMapIndicadorValue(tipoIndicador.gps),
            obtenerMapIndicadorValue(tipoIndicador.lastPosition),
            obtenerMapIndicadorValue(tipoIndicador.diesel),
            obtenerMapIndicadorValue(tipoIndicador.brecha),
            obtenerMapIndicadorValue(tipoIndicador.unidadSinViaje),
            obtenerMapIndicadorValue(tipoIndicador.horasManejo),
            obtenerMapIndicadorValue(tipoIndicador.botonPanico),
            obtenerMapIndicadorValue(tipoIndicador.totales),
            obtenerMapIndicadorValue(tipoIndicador.seguimiento),
            obtenerMapIndicadorValue(tipoIndicador.detenidoZonaNoSegura),
            obtenerMapIndicadorValue(tipoIndicador.despacho),
        ])

        const totalesViajes = totales.get(tipoIndicador.totales);

        for (let viaje of viajes) {
            if (viaje?.indicadores == null)
                continue;


            for (let indicadorId in viaje.indicadores) {
                indicadorId = parseInt(indicadorId)
                if (viaje.indicadores[indicadorId] == null)
                    continue
                const colorId = viaje.indicadores[indicadorId].color
                let totalIndicador = totales.get(indicadorId);
                const total = totalIndicador.get(colorId) + 1;
                totalIndicador.set(colorId, total);
            }

            const total = totalesViajes.get(viaje.color) + 1;
            totalesViajes.set(viaje.color, total);
        }
        totales.set(tipoIndicador.totales, totalesViajes)
        setTotales(totales)
    }

    useEffect(()=>{
        const icons = []
        addIfVisible(icons,{name: "Velocidad", id: tipoIndicador.velocidad, opciones: indicadoresVelocidad, title:'Velocidad'},indicadoresVisibles)
        addIfVisible(icons,{name: "Motor", id: tipoIndicador.motor, opciones: indicadoresMotor, title:'Ralenty'},indicadoresVisibles)
        addIfVisible(icons,{name: "Gps", id: tipoIndicador.gps, opciones: indicadoresGps, title: 'SeÃ±al GPS'},indicadoresVisibles)
        addIfVisible(icons,{name: "HorasManejo", id: tipoIndicador.horasManejo, opciones: horasDeManejo, title: 'Horas de manejo'},indicadoresVisibles)
        addIfVisible(icons,{name: "Brecha", id: tipoIndicador.brecha, opciones: indicadoresBrecha, title:'SeparaciÃ³n Caja'},indicadoresVisibles)
        addIfVisible(icons,{name: "LastPosition", id: tipoIndicador.lastPosition, opciones: indicadoresLastPosition, title: 'ETA'},indicadoresVisibles)
        addIfVisible(icons,{name: "GeocercaProhibida", id: tipoIndicador.geocercaProhibida, opciones: indicadoresGeocercaProhibida, title:'Zona prohibida'},indicadoresVisibles)
        addIfVisible(icons,{name: "SinViaje", id: tipoIndicador.unidadSinViaje, opciones: indicadoresUnidadSinViaje, title:'Unidad en movimiento sin viaje'},indicadoresVisibles)
        addIfVisible(icons,{name: "BotonPanico", id: tipoIndicador.botonPanico, opciones: botonPanico, title: 'BotÃ³n de pÃ¡inico'},indicadoresVisibles)
        addIfVisible(icons,{name: "Seguimiento", id: tipoIndicador.seguimiento, opciones: seguimiento, title: 'Seguimiento'},indicadoresVisibles)
        addIfVisible(icons,{name: "Despacho", id: tipoIndicador.despacho, opciones: despacho, title: 'Despacho'},indicadoresVisibles)
        addIfVisible(icons,{name: "DetenidoZonaNoSegura", id: tipoIndicador.detenidoZonaNoSegura, opciones: seguimiento, title: 'Detenido Zona no Segura'},indicadoresVisibles)
        addIfVisible(icons,{name: "Diesel", id: tipoIndicador.diesel, opciones: indicadoresDiesel, title: 'ExtracciÃ³n de diesel'},indicadoresVisibles)
        setIcons(icons)
    },[soloUnidades,indicadoresVisibles])

    useEffect(() => {
        obtenerTotales(viajes)
    }, [viajes])


const getClassSeleccionado = (colorId) => {
    return filtroSeleccionado.indicadorId === indicador.id &&
           filtroSeleccionado.colorIds.includes(colorId)
        ? "seleccionado"
        : "";
};

const getContrastePorColorId = (colorId) => {
    const color = colorIndicadores[colorId] ?? "gris";

    return color !== "gris" && color !== "amarillo"
        ? "Contraste"
        : "";
};

const coloresCss = {
    gris: "#E3E9ED",
    verde: "green",
    amarillo: "#F9DA3A",
    rojo: "#FF0000",
    azul: "#2196F3",
    rosa: "#f66abe"
};

const getFondoMulticolor = (colorIds) => {
    const ancho = 100 / colorIds.length;

    const segmentos = colorIds.flatMap((colorId, index) => {
        const nombreColor = colorIndicadores[colorId] ?? "gris";
        const color = coloresCss[nombreColor] ?? coloresCss.gris;
        const inicio = index * ancho;
        const fin = (index + 1) * ancho;

        return [
            `${color} ${inicio}%`,
            `${color} ${fin}%`
        ];
    });

    return `linear-gradient(to right, ${segmentos.join(", ")})`;
};

const renderIconoIndicador = (icon) => {
    const colorIds =
        filtroSeleccionado.indicadorId === icon.id
            ? filtroSeleccionado.colorIds
            : [];

    if (colorIds.length === 0) {
        return (
            <span className="gris">
                <SeguimientoIcon
                    iconName={icon.name}
                    continuePropagation={true}
                />
            </span>
        );
    }

    if (colorIds.length === 1) {
        const colorId = colorIds[0];

        return (
            <span className={colorIndicadores[colorId]}>
                <SeguimientoIcon
                    iconName={`${icon.name}${getContrastePorColorId(colorId)}`}
                    continuePropagation={true}
                />
            </span>
        );
    }

    return (
        <span
            className="seg-icono-multicolor"
            style={{
                background: getFondoMulticolor(colorIds)
            }}
        >
            <SeguimientoIcon
                iconName={`${icon.name}Contraste`}
                continuePropagation={true}
            />
        </span>
    );
};

const getTotalSeleccionado = (indicadorId) => {
    if (filtroSeleccionado.indicadorId !== indicadorId) {
        return null;
    }

    return filtroSeleccionado.colorIds.reduce(
        (total, colorId) =>
            total + (totales.get(indicadorId)?.get(colorId) ?? 0),
        0
    );
};

    const getTotal =(indicador, color)=>{
        return  totales.get(indicador.id).get(color.colorId)
    }

    return (
        <>
            <div className="seg-total-indicadores">
                <div className={`seg-total`} style={{cursor: 'default'}} onClick={(e)=>
                    mostrarDetalle(e, {id:tipoIndicador.totales, opciones: contadorTotales })}
                >
                    {viajesFiltrados.length}
                </div>
                <div className={`seg-indicadores`}>
                    {icons.map(icon =>
                        <div key={icon.name} className={`seg-total-icon`}
                             onClick={(e) => mostrarDetalle(e, icon)}
                             title={icon.title}>
                            {renderIconoIndicador(icon)}
                            <span className={`seg-total-cantidad`}>
                                {getTotalSeleccionado(icon.id)}
                            </span>
                        </div>
                    )}
                </div>
            </div>
            <OverlayPanel ref={op} id="overlay_panel" dismissable={true}
                          style={{width: '90px'}} className="seg-overlay-indicador">
                <div className={'seg-filtros-indicadores'}>
                    {indicador.opciones.map(color =>
                        <div className={`seg-filtro-indicador`} key={color.colorId} title={color.tooltip}
                             onClick={() => seleccionarFiltro(indicador.id, color.colorId)}>
                            <div className={`seg-filtro ${color.color} ${getClassSeleccionado(color.colorId)}`}>
                            </div>
                            <span>
                                {getTotal(indicador,color)}
                            </span>
                        </div>
                    )}
                </div>
            </OverlayPanel>
        </>


    )
}

export default TotalIndicadores
